import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { NgControl, NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[sigecom-input]',
})
export class InputDirective implements OnInit, OnDestroy {
  private attributeName: string = 'style';
  private css: string = `
    background-color: transparent;
    border: none;
    box-shadow: none;
    width: 100%;
    outline: none;
    color: #787878;
  `;

  constructor(
    private elementRef: ElementRef,
    @Optional() private ngControl: NgControl,
    @Optional() private ngModel: NgModel,
  ) {}

  @Input() sigecomInputMaxLength?: number;
  private valueChangesSub?: Subscription;

  ngOnInit() {
    const el = this.elementRef.nativeElement;

    if (el.type === 'text') {
      if (el.maxLength == undefined) {
        el.maxLength = this.sigecomInputMaxLength ?? 100;
      }
    }

    el.setAttribute(this.attributeName, this.css);

    this.elementRef.nativeElement.classList.add('input', 'input-file-upload');

    const aplicarEstadoValor = (valor: any) => {
      if (valor && valor.toString().trim() !== '') {
        if (!valor.toString().toLowerCase().startsWith('selec')) {
          el.style.color = '#000';
        }
      } else {
        el.style.color = '#787878';
      }
    };

    // Prefer reactive form control (NgControl) but support template-driven NgModel too
    const controlValue = this.ngControl?.control?.value ?? this.ngModel?.model;
    aplicarEstadoValor(controlValue ?? el.value);

    const valueChanges$ =
      this.ngControl?.control?.valueChanges ?? this.ngModel?.valueChanges;
    if (valueChanges$) {
      this.valueChangesSub = valueChanges$.subscribe((valor) => {
        aplicarEstadoValor(valor);
      });
      return;
    }

    // Fallback: listen to native input events when not using Angular forms
    el.addEventListener('input', (event: Event) => {
      const valor = (event.target as HTMLInputElement).value;
      aplicarEstadoValor(valor);
    });
  }
  ngOnDestroy(): void {
    this.valueChangesSub?.unsubscribe();
  }
}
